import { TooltipButton } from "~/components/ui/button"
import { RefreshCwIcon } from "lucide-react"
import { useOrganization } from "~/hooks/useOrganization"
import { useTeam } from "~/hooks/useTeam"
import { cn } from "~/lib/utils"
import { api } from "~/trpc/react"

import { DropdownMenuItem } from "../ui/dropdown-menu"
import { TooltipProvider } from "../ui/tooltip"

export function RefreshButton({
	className,
	menuItem = false
}: {
	className?: string
	menuItem?: boolean
}) {
	const { organization } = useOrganization()
	const utils = api.useUtils()
	const { team } = useTeam()
	const issues = api.issues.getTeamIssues.useQuery(
		{
			teamId: team?.id ?? ""
		},
		{
			enabled: false
		}
	)
	const teams = api.user.getTeams.useQuery(
		{
			organizationId: organization?.id ?? ""
		},
		{
			enabled: false
		}
	)
	const badges = api.user.getBadges.useQuery(
		{
			organizationId: organization?.id ?? ""
		},
		{
			enabled: false
		}
	)
	const orgs = api.user.getOrgs.useQuery(undefined, {
		enabled: false
	})
	const userIssues = api.issues.getUserIssues.useQuery(
		{ organizationId: organization?.id ?? "" },
		{
			enabled: false
		}
	)

	const handleClick = () => {
		issues.refetch()
		teams.refetch()
		badges.refetch()
		orgs.refetch()
		if (organization) void utils.issues.getUserIssues.invalidate()
	}

	const isLoading =
		issues.isRefetching ||
		teams.isRefetching ||
		badges.isRefetching ||
		orgs.isRefetching ||
		userIssues.isRefetching

	if (menuItem) {
		return (
			<DropdownMenuItem disabled={isLoading} onSelect={handleClick}>
				<RefreshCwIcon
					className={cn(isLoading && "animate-spin", "size-4 text-icons")}
				/>{" "}
				Refresh
			</DropdownMenuItem>
		)
	}

	return (
		<TooltipProvider>
			<TooltipButton
				variant="outline"
				size="icon"
				onClick={handleClick}
				aria-label="Refresh issues"
				className={className}
				tooltip="Refresh"
			>
				<RefreshCwIcon
					className={cn(isLoading && "animate-spin", "size-4 text-icons")}
				/>
			</TooltipButton>
		</TooltipProvider>
	)
}
